import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const useFlexScrollStyles = makeStyles((_theme) =>
  createStyles({
    scrollWrapper: {
      height: '100%',
      width: '100%',
      position: 'relative',
    },
    flexScroll: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      overflow: 'auto',
    },
  })
);

export default useFlexScrollStyles;
